import { Component, Inject, Optional } from '@angular/core';
import { LoadingSpaceType } from 'src/app/core/services/import-export-service-types';
import { overflowPopupCopyKey } from 'src/app/shared/helpers/pallet-overflow-recommendation.helper';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';
import { MODAL_DATA } from 'src/app/modal/modal.service';

export interface PalletOverflowRecommendationResult {
  confirmed: boolean;
  doNotShowAgain: boolean;
}

export interface PalletOverflowRecommendationPopupData {
  spaceType?: LoadingSpaceType;
}

@Component({
  selector: 'gl-pallet-overflow-recommendation-popup',
  templateUrl: './pallet-overflow-recommendation-popup.component.html',
  styleUrls: ['./pallet-overflow-recommendation-popup.component.scss'],
  standalone: false,
})
export class PalletOverflowRecommendationPopupComponent {
  public doNotShowAgain = false;

  constructor(
    private modalRef: ModalOverlayRef,
    @Optional() @Inject(MODAL_DATA) public data?: PalletOverflowRecommendationPopupData,
  ) {}

  public get descriptionKey(): string {
    return overflowPopupCopyKey(this.data?.spaceType);
  }

  public close(confirmed: boolean): void {
    this.modalRef.close({
      confirmed,
      doNotShowAgain: this.doNotShowAgain,
    } as PalletOverflowRecommendationResult);
  }
}
